export enum PersonaType {
  TRAINING_MANAGER = 'training_manager',
  STOREFRONT_OWNER = 'storefront_owner',
  LEARNER = 'learner'
}
